<template>
    <b-row class="ld-over" :class="[{'running': dataLoading}]">
        <div class="ld ld-ring ld-spin" v-if="dataLoading"></div>
        <b-col xxs="12">
            <vuetable
                ref="vuetable"
                class="order-with-arrow"

                pagination-path

                :api-url="url"
                :per-page="perPageValue"
                :reactive-api-url="true"
                :fields="fields"
                :query-params="makeQueryParams"
                :load-on-start="loadOnStart"

                @vuetable:pagination-data="onPaginationData"
                @vuetable:loading="showLoadingAnimation"
                @vuetable:load-success="hideLoadingAnimation"
            >

                <!--suppress XmlUnboundNsPrefix, JSUnusedLocalSymbols -->
                <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
                    <slot :name="slot" v-bind="scope"/>
                </template>

            </vuetable>

            <vuetable-pagination-bootstrap
                class="mt-4"
                ref="pagination"
                @vuetable-pagination:change-page="onChangePage"
                v-show="showPagination"/>

        </b-col>
    </b-row>
</template>

<script>
import VueTableMixin from './VueTableMixin';

export default {
    name: 'simple-vue-table',
    mixins: [VueTableMixin]

};
</script>
